import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { ChatDots, Trash } from 'react-bootstrap-icons';
import './Node.css';

const SendSMSNode = ({ data, id, outputEdges, onEdgeCountChange, edgeLabels }) => {
  // Define color scheme
  const colors = {
    container: 'custom-node node-rounded-lg node-border-green-light',
    header: 'node-header node-bg-green-gradient node-border-green-bottom',
    text: 'node-text-green',
    handle: 'node-handle-small node-handle-green-light'
  };

  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`${colors.container} node-hover-lift`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button */}
      <div 
        className={`delete-btn delete-btn.top-center ${isHovered ? 'show' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <Trash className='icon-trash'/>
      </div>

      <div className={colors.header}>
        <div className="node-header-content">
          <ChatDots className='node-icon' style={{ color: '#15803d' }}/>
          <span className={`node-title ${colors.text}`}>Send SMS</span>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Left}
        className={colors.handle}
      />

      <div className="node-output-handles">
        {Array.from({ length: outputEdges }).map((_, index) => (
          <Handle
            key={`output-${index}`}        
            type="source"
            position={Position.Right}
            id={`output-${index}`}
            className={colors.handle}
            style={{ 
              top: `${((index + 1) * 100) / (outputEdges + 1)}%`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default SendSMSNode; 
